import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-700 mb-1" }
const _hoisted_2 = { class: "relative w-full flex flex-col" }
const _hoisted_3 = ["type", "name", "value"]
const _hoisted_4 = ["name", "value", "type"]
const _hoisted_5 = {
  key: 0,
  class: "text-red-800 text-sm ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col py-2 px-3 relative w-full", _ctx.tclass])
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.type == 'textarea')
        ? (_openBlock(), _createElementBlock("textarea", _mergeProps({
            key: 0,
            class: ["p-2 border rounded-lg bg-white focus:outline-none focus:ring-2 transition-colors duration-150", [
          _ctx.error && _ctx.error.length > 0 ? 'border-red-800' : 'border-gray-300',
          `focus:ring-${_ctx.theme}-200 focus:border-${_ctx.theme}-500`,
        ]],
            type: _ctx.type,
            name: _ctx.name,
            value: _ctx.value,
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, _ctx.$attrs), null, 16, _hoisted_3))
        : (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 1,
            class: ["p-2 border rounded-lg bg-white focus:outline-none focus:ring-2 transition-colors duration-150", [
          _ctx.error && _ctx.error.length > 0 ? 'border-red-800' : 'border-gray-300',
          `focus:ring-${_ctx.theme}-200 focus:border-${_ctx.theme}-500`,
        ]],
            name: _ctx.name,
            value: _ctx.value,
            type: _ctx.type || 'text',
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, _ctx.$attrs), null, 16, _hoisted_4))
    ]),
    (_ctx.error && _ctx.error.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}